<template>
  <div>
    <!-- <div class="left content-left">
      <AreaTree ref="areaTree" :moduleName="moduleName" v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div> -->
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>车场名称:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for="a_name">锁编号</label>
            <input
              v-model.trim="search.deviceSn"
              class="form-control"
              type="text"
              placeholder="请输入锁编号"
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label>泊位号</label>
            <input
              v-model.trim="search.spaceNum"
              class="form-control"
              type="text"
              placeholder="请输入泊位号"
              size="12"
              v-noBlankSpace
            />
          </div>
           <div class="form-group">
            <label>告警事件</label>
            <input
              v-model.trim="search.content"
              class="form-control"
              type="text"
              placeholder="请输入告警事件"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label>处理状态</label>
            <el-select v-model="search.isHandle" placeholder="请选择处理状态" clearable style="width: 150px;">
              <el-option label="未处理" value="n"></el-option>
              <el-option label="已处理" value="y"></el-option>
            </el-select>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-primary"
                id="search_btn"
                @click="searchList"
              >
                查询
              </button>
            </span>
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-primary"
                id="search_btn"
                @click="downloadData"
              >
                导出
              </button>
            </span>
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="clearSearch"
              >
                重置
              </button>
            </span>
            <!-- <span class='add_btn'><button  type="button" class="btn btn-default" id="addarea" >添加</button></span> -->
            <!-- <span class="download_btn"><ExportExcel v-bind:tableListData="this.tableListData" v-bind:tableListDataAll="this.tableListDataAll" v-bind:downloadFileds="this.downloadFileds"></ExportExcel></span> -->
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>

      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingName"
            width="150"
          ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            label="告警来源"
            prop="alarmSource"
            width="120"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="告警时间"
            prop="lastUpTime"
            width="150"
          ></el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="设备类型"
            prop="type"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="锁编号"
            prop="devSn"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="锁名称"
            prop="lockName"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="锁类型"
            prop="lockType"
            width="120"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="泊位号"
            prop="spaceNum"
            width="120"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="告警事件"
            prop="content"
            min-width="200"
          >
            <template slot-scope="scope">
              <el-tag
                :type="getAlarmContentType(scope.row.content)"
                size="small"
                effect="plain"
              >
                {{ scope.row.content || '-' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="告警说明"
            prop=""
            width="120"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="处理状态"
            prop="isHandle"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.isHandle === 'n' || !scope.row.isHandle ? 'danger' : 'success'"
                size="small"
              >
                {{ scope.row.isHandle === 'n' || !scope.row.isHandle ? '未处理' : '已处理' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="处理人"
            prop="handler"
            width="120"
          ></el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="剩余电量/电压"
            prop="pow"
          >
           
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="处理时间"
            prop="uptTime"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="处理结果"
            prop="handleResult"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.handleResult"
                :type="scope.row.handleResult === '已解决' ? 'success' : 'warning'"
                size="small"
              >
                {{ scope.row.handleResult }}
              </el-tag>
              <span v-else style="color: #909399;">-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="280"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <button
                class="edit"
                type="button"
                @click="showMaintenanceInfo(scope.row)"
              >
                查看运维人员信息
              </button>
              <button
                v-if="scope.row.isHandle === 'n' || !scope.row.isHandle"
                class="edit"
                type="button"
                @click="handleAlarm(scope.row)"
              >
                处理
              </button>
              <button
                v-else
                class="edit"
                type="button"
                @click="showHandleDetail(scope.row)"
              >
                处理详情
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
    
    <!-- 处理弹窗 -->
    <el-dialog
      title="处理告警事件"
      :visible.sync="handleDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <div v-if="currentHandleRow">
        <!-- 泊位详情 -->
        <div class="detail-section">
          <div class="section-title">泊位详情</div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="车场名称">{{ currentHandleRow.parkingName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="泊位号">{{ currentHandleRow.spaceNum || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <!-- 设备详情 -->
        <div class="detail-section">
          <div class="section-title">设备详情</div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="锁编号">{{ currentHandleRow.devSn || '-' }}</el-descriptions-item>
            <el-descriptions-item label="锁名称">{{ currentHandleRow.lockName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="锁类型">{{ currentHandleRow.lockType || '-' }}</el-descriptions-item>
            <el-descriptions-item label="剩余电量/电压">{{ currentHandleRow.pow || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <!-- 告警事件 -->
        <div class="detail-section">
          <div class="section-title">告警事件</div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="告警时间">{{ currentHandleRow.lastUpTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="告警来源">{{ currentHandleRow.alarmSource || '-' }}</el-descriptions-item>
            <el-descriptions-item label="告警事件" :span="2">
              <el-tag
                :type="getAlarmContentType(currentHandleRow.content)"
                size="small"
                effect="plain"
              >
                {{ currentHandleRow.content || '-' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="告警说明" :span="2">{{ currentHandleRow.alarmDescription || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <!-- 处理表单 -->
        <div class="detail-section">
          <div class="section-title">处理信息</div>
          <el-form :model="handleForm" :rules="handleFormRules" ref="handleForm" label-width="100px">
            <el-form-item label="处理说明" prop="handleDescription">
              <el-input
                type="textarea"
                :rows="4"
                v-model="handleForm.handleDescription"
                placeholder="请输入处理说明"
              ></el-input>
            </el-form-item>
            <el-form-item label="处理结果" prop="handleResult">
              <el-select v-model="handleForm.handleResult" placeholder="请选择处理结果" style="width: 100%;">
                <el-option label="已解决" value="已解决"></el-option>
                <el-option label="未解决" value="未解决"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHandle">确 定</el-button>
      </div>
    </el-dialog>
    
    <!-- 处理详情弹窗 -->
    <el-dialog
      title="处理详情"
      :visible.sync="handleDetailDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <div v-if="currentHandleDetail">
        <!-- 泊位详情 -->
        <div class="detail-section">
          <div class="section-title">泊位详情</div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="车场名称">{{ currentHandleDetail.parkingName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="泊位号">{{ currentHandleDetail.spaceNum || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <!-- 设备详情 -->
        <div class="detail-section">
          <div class="section-title">设备详情</div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="锁编号">{{ currentHandleDetail.devSn || '-' }}</el-descriptions-item>
            <el-descriptions-item label="锁名称">{{ currentHandleDetail.lockName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="锁类型">{{ currentHandleDetail.lockType || '-' }}</el-descriptions-item>
            <el-descriptions-item label="剩余电量/电压">{{ currentHandleDetail.pow || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <!-- 告警事件 -->
        <div class="detail-section">
          <div class="section-title">告警事件</div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="告警时间">{{ currentHandleDetail.lastUpTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="告警来源">{{ currentHandleDetail.alarmSource || '-' }}</el-descriptions-item>
            <el-descriptions-item label="告警事件" :span="2">
              <el-tag
                :type="getAlarmContentType(currentHandleDetail.content)"
                size="small"
                effect="plain"
              >
                {{ currentHandleDetail.content || '-' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="告警说明" :span="2">{{ currentHandleDetail.alarmDescription || '-' }}</el-descriptions-item>
            <el-descriptions-item label="处理状态">
              <el-tag type="success" size="small">已处理</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处理时间">{{ currentHandleDetail.uptTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="处理人">{{ currentHandleDetail.handler || '-' }}</el-descriptions-item>
            <el-descriptions-item label="处理结果">
              <el-tag
                :type="currentHandleDetail.handleResult === '已解决' ? 'success' : 'warning'"
                size="small"
              >
                {{ currentHandleDetail.handleResult || '-' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处理说明">{{ currentHandleDetail.handleDescription || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDetailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    
    <!-- 运维人员信息弹窗 -->
    <el-dialog
      title="运维人员信息"
      :visible.sync="maintenanceInfoDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-descriptions :column="2" border v-if="currentMaintenanceInfo">
        <el-descriptions-item label="姓名">{{ currentMaintenanceInfo.name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ currentMaintenanceInfo.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="负责区域" :span="2">{{ currentMaintenanceInfo.responsibleArea || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ currentMaintenanceInfo.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="maintenanceInfoDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import { equipWarn } from "@/api/url";

import Page from "../../commons/page.vue";

import AreaTree from "../../commons/areaTree.vue";

import Refresh from "../../commons/refresh.vue";

import SearchParking from "@/page/commons/searchParking";

export default {
  data() {
    return {
      moduleName: "",

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        deviceSn: "",
        content:""
        // stationSn:""
      },
      tableListData: [],
      treeData: {
        deviceType: "",
      },
      tableLoading: false,
      handleDialogVisible: false, // 处理弹窗
      handleDetailDialogVisible: false, // 处理详情弹窗
      maintenanceInfoDialogVisible: false, // 运维人员信息弹窗
      currentHandleDetail: null, // 当前处理详情
      currentHandleRow: null, // 当前要处理的行
      currentMaintenanceInfo: null, // 当前运维人员信息
      handleForm: {
        handleResult: "", // 处理结果
        handleDescription: "", // 处理说明
      },
      handleFormRules: {
        handleResult: [
          { required: true, message: "请选择处理结果", trigger: "change" }
        ],
        handleDescription: [
          { required: true, message: "请输入处理说明", trigger: "blur" }
        ],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      var _this = this;
      _this.tableListDataTitle = [];
      _this.tableListData = [];
      _this.tableLoading = true;
      this.$get(equipWarn(), {
        limit: this.search.pageSize,
        page: curPage,
        devSn: this.search.deviceSn,
        spaceNum: this.search.spaceNum,
        content: this.search.content,
        isHandle: this.search.isHandle || null,
        parkingId: this.parking?.parkingId ?? null,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = rows.map((item) => {
          if (
            item.parkingId &&
            typeof JSON.parse(item.parkingId) === "object"
          ) {
            item.parkingName = JSON.parse(item.parkingId).parkingName;
          }
          return item;
        });
        
        // 添加一条已处理的测试数据
        const testData = {
          id: 'test_' + Date.now(),
          parkingName: '测试停车场',
          lastUpTime: new Date().toLocaleString('zh-CN'),
          devSn: 'TEST001',
          lockName: '测试锁001',
          lockType: '平板车锁',
          spaceNum: 'A001',
          content: '设备故障告警',
          alarmSource: '系统自动检测',
          alarmDescription: '设备出现异常，需要及时处理',
          isHandle: 'y',
          uptTime: new Date().toLocaleString('zh-CN'),
          handler: '测试用户',
          handleResult: '已解决',
          handleDescription: '已更换故障部件，设备恢复正常运行',
        };
        _this.tableListData.unshift(testData);
        // _this.$nextTick(this.canvasPow);
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      })
      .catch((error) => {
        console.error("加载告警数据失败:", error);
        _this.$message.error("加载告警数据失败，请稍后重试");
      })
      .finally(() => {
        _this.tableLoading = false;
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.deviceSn = "";
      this.search.spaceNum = "";
      this.search.content = "";
      this.search.isHandle = "";
      this.tableList(this.search.pageNumber);
    },
    // 处理告警
    handleAlarm(row) {
      this.currentHandleRow = row;
      this.handleForm.handleDescription = "";
      this.handleDialogVisible = true;
    },
    // 提交处理
    submitHandle() {
      this.$refs.handleForm.validate((valid) => {
        if (valid) {
          // TODO: 调用API处理告警
          // 这里需要根据实际API接口进行实现
          // 示例：
          // this.$putRequest(handleAlarmApi(), {
          //   id: this.currentHandleRow.id,
          //   handleDescription: this.handleForm.handleDescription,
          //   handler: this.$store.state.user.name, // 当前用户
          // }).then((res) => {
          //   if (res.status === 200) {
          //     this.$message.success("处理成功");
          //     this.handleDialogVisible = false;
          //     this.tableList(this.search.pageNumber);
          //   }
          // });
          
          // 临时处理：直接更新本地数据
          const row = this.currentHandleRow;
          row.isHandle = 'y';
          row.uptTime = new Date().toLocaleString('zh-CN');
          row.handler = '当前用户'; // 应该从用户信息获取
          row.handleResult = this.handleForm.handleResult;
          row.handleDescription = this.handleForm.handleDescription;
          
          this.$message.success("处理成功");
          this.handleDialogVisible = false;
          this.$refs.handleForm.resetFields();
        }
      });
    },
    // 显示处理详情
    showHandleDetail(row) {
      this.currentHandleDetail = { ...row };
      this.handleDetailDialogVisible = true;
    },
    // 显示运维人员信息
    showMaintenanceInfo(row) {
      // TODO: 根据row数据获取运维人员信息
      // 这里先使用模拟数据，实际应该从API获取
      this.currentMaintenanceInfo = {
        name: '张三',
        phone: '13800138000',
        responsibleArea: '测试停车场区域',
        remark: '负责NB地锁设备的日常维护和故障处理',
      };
      // 实际API调用示例：
      // this.$get(`/api/maintenance/info/${row.lockId}`).then((res) => {
      //   if (res.status === 200) {
      //     this.currentMaintenanceInfo = res.data;
      //   }
      // });
      this.maintenanceInfoDialogVisible = true;
    },
    // 获取告警内容类型（用于标签颜色）
    getAlarmContentType(content) {
      if (!content) return "info";
      const contentStr = content.toString().toLowerCase();
      
      // 严重告警 - 红色
      if (
        contentStr.includes("故障") ||
        contentStr.includes("异常") ||
        contentStr.includes("损坏") ||
        contentStr.includes("水淹") ||
        contentStr.includes("水浸")
      ) {
        return "danger";
      }
      
      // 警告 - 橙色
      if (
        contentStr.includes("电量") ||
        contentStr.includes("电压") ||
        contentStr.includes("低电量") ||
        contentStr.includes("信号")
      ) {
        return "warning";
      }
      
      // 一般信息 - 蓝色
      return "info";
    },
    downloadData() {
      const { deviceSn, spaceNum, content } = this.search;
      this.$downloadFileRequest(
        "/api/parking/nbOnerankdev/alarmExport",
        {
          parkingId: this.parking?.parkingId ?? null,
          deviceSn: deviceSn ? deviceSn : null,
          spaceNum: spaceNum ? spaceNum : null,
          content: content ? content : null,
        },
        "NB地锁告警事件"
      );
    },
    // canvasPow() {
    //   var _this = this;
    //   for (let item of _this.tableListData) {
    //     console.log(item.type);

    //     var canvas = document.getElementById(item.devSn);
    //     canvas.style = "border:1px solid #696969";
    //     var context = canvas.getContext("2d");
    //     context.clearRect(0, 0, 20, 10);
    //     if (item.type == "nb地磁") {
    //       if (item.pow > 0) {
    //         context.fillStyle = "green";
    //         context.fillRect(0, 0, 20, 10);
    //       }
    //     } else {
    //       if (item.pow >= 80) {
    //         context.fillStyle = "green";
    //       } else if (item.pow >= 40 && item.pow < 80) {
    //         context.fillStyle = "#FF6100";
    //       } else if (item.pow < 40) {
    //         context.fillStyle = "red";
    //       }
    //       context.fillRect(0, 0, (20 / 100) * item.pow, 10);
    //     }

    //     var canvas1 = document.getElementById(item.devSn + "s");
    //     var context1 = canvas1.getContext("2d");
    //     context1.fillStyle = "#696969";
    //     context1.fillRect(0, 0, 5, 5);
    //   }
    // },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
  },
  components: {
    Page,
    AreaTree,
    Refresh,
    SearchParking,
  },
  created: function () {},
  mounted: function () {
    this.tableList(this.search.pageNumber);
  },

  watch: {},
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}

.list-right {
  padding-bottom: 100px !important; /* 为分页组件留出空间 */
  box-sizing: border-box;
}

.pagbox {
  position: absolute;
  bottom: 10px;
  right: 20px;
  background: white;
  padding: 10px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
/* .edit,
.delete,
.chargingRules {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
} */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 事件详情弹窗样式 */
.event-detail-container {
  padding: 10px 0;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #409EFF;
}
</style>